import React from "react";
import { Link } from "react-router-dom";
import Logo from "@/components/Logo";
import { ShieldCheck, Moon } from "lucide-react";
import { useI18n } from "@/context/I18nContext";

export function AuthAside({ titleKey, subKey, showEncrypted = false }) {
  const { t } = useI18n();
  return (
    <div className="hidden lg:flex emerald-surface relative overflow-hidden grain flex-col justify-between p-12" data-testid="auth-aside">
      <Link to="/" className="relative z-10"><Logo size={40} textClass="text-2xl text-white" accentClass="text-amber-200" /></Link>

      {/* Decorative glass — no photo */}
      <div className="pointer-events-none absolute -right-20 top-16 h-80 w-80 rounded-full bg-white/10 blur-3xl" />
      <div className="pointer-events-none absolute right-8 top-40 h-44 w-44 rounded-3xl border border-white/15 bg-white/5 backdrop-blur-sm rotate-12" />
      <div className="pointer-events-none absolute right-28 bottom-52 h-24 w-24 rounded-2xl border border-white/10 bg-white/5 backdrop-blur-sm -rotate-6" />

      <div className="relative z-10 max-w-md">
        <div className="inline-flex items-center gap-2 rounded-full bg-white/10 backdrop-blur px-3 py-1.5 text-white/90 text-xs font-semibold mb-5">
          <Moon className="h-3.5 w-3.5" /> TCF Canada · AI coaching
        </div>
        <h2 className="font-display text-4xl font-semibold text-white leading-tight">{t(titleKey)}</h2>
        <p className="mt-4 text-white/80 leading-relaxed">{t(subKey)}</p>
        {showEncrypted && (
          <div className="mt-6 inline-flex items-center gap-2 text-white/85 text-sm"><ShieldCheck className="h-4 w-4" /> {t("auth.encrypted")}</div>
        )}
      </div>
      <div className="relative z-10 text-white/60 text-sm">© 2026 All In One French</div>
    </div>
  );
}
